module.exports = __webpack_public_path__ + "static/media/i3766960240.ec271da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/i3766960240.jpg
// module id = 92
// module chunks = 0